<div id="wrap">
  <div id="head_wrap">
    <div class="common-back-btn-sight" id="closeBtn" (click)="close();">
      <span>×</span>
    </div>
    <h1 id="title" class="fontSize24">引导</h1>
  </div>
  <div id="video-vector">
  </div>
</div>
<div id="wrapVector">
  <div id="head_wrap">
    <div class="common-back-btn-sight"  (click)="closeCard();"  id="closeBtn">
      <span>×</span>
    </div>
    <div id="title2Before">
      <h1 id="title2" class="fontSize16">你的影响力风格是什么样的？ (只可选一张)</h1>
    </div>
    <div id="title2After">
      <h1 id="title2" class="fontSize16">你的影响力风格是什么样的？</h1>
    </div>
  </div>
  <div id="cards">
    <div class="card" id="card0">
      <div>
        <img class="cardFrontImage" alt="" src="{{assetsRoute}}/picture/courselearning/judge.png"  id="cardFrontImage0"/>
      </div>
      <div class="fontSize18 cardText">
        法官
      </div>
      <div class="cardFront" id="cardFront0">
        <textarea id="textEnter0" class="textEnterNormal fontSize16 lineHeight23" (blur)="goToTop()"  placeholder="以理服人是我的影响风格。(最多100字)"  maxlength="100" (input)="onTextEnter($event, 0)"></textarea>
        <div class="submit fontSize19" (click)="onVectorSubmit(0)">
          <span>提交我的风格</span>
        </div>
      </div>
      <div id="cardBack0" class="cardBack">
        <p class="textEnterAfter1 textEnterAfter fontSize16 lineHeight23" id="textEnterAfter0"></p>
        <div class="submit2 fontSize19" (click)="onVectorClose()">
          <span>关闭</span>
        </div>
      </div>
    </div>
    <div class="card" id="card1">
      <div>
        <img class="cardFrontImage" alt="" src="{{assetsRoute}}/picture/courselearning/computer.png"  id="cardFrontImage1"/>
      </div>
      <div class="fontSize18 cardText">
        计算机
      </div>
      <div class="cardFront" id="cardFront1">
        <textarea id="textEnter1" class="textEnterNormal fontSize16 lineHeight23" (blur)="goToTop()"  placeholder="我喜欢用数据说话，让别人不得不服。(最多100字)"  maxlength="100" (input)="onTextEnter($event, 1)"></textarea>
        <div class="submit fontSize19" (click)="onVectorSubmit(1)">
          <span>提交我的风格</span>
        </div>
      </div>
      <div id="cardBack1" class="cardBack">
        <p class="textEnterAfter1 textEnterAfter fontSize16 lineHeight23" id="textEnterAfter1"></p>
        <div class="submit2 fontSize19" (click)="onVectorClose()">
          <span>关闭</span>
        </div>
      </div>
    </div>
    <div class="card" id="card2">
      <div>
        <img class="cardFrontImage" alt="" src="{{assetsRoute}}/picture/courselearning/tangseng.png"  id="cardFrontImage2"/>
      </div>
      <div class="fontSize18 cardText">
        唐僧
      </div>
      <div class="cardFront" id="cardFront2">
        <textarea id="textEnter2" class="textEnterNormal fontSize16 lineHeight23" placeholder="我喜欢碎碎念，念到别人答应为止。(最多100字)"  maxlength="100" (blur)="goToTop()"  (input)="onTextEnter($event, 2)"></textarea>
        <div class="submit fontSize19" (click)="onVectorSubmit(2)">
          <span>提交我的风格</span>
        </div>
      </div>
      <div id="cardBack2" class="cardBack">
        <p class="textEnterAfter1 textEnterAfter fontSize16 lineHeight23" id="textEnterAfter2"></p>
        <div class="submit2 fontSize19" (click)="onVectorClose()">
          <span>关闭</span>
        </div>
      </div>
    </div>
    <div class="card" id="card3">
      <div>
        <img class="cardFrontImage" alt="" src="{{assetsRoute}}/picture/courselearning/general.png"  id="cardFrontImage3"/>
      </div>
      <div class="fontSize18 cardText">
        将领
      </div>
      <div class="cardFront" id="cardFront3">
        <textarea id="textEnter3" class="textEnterNormal fontSize16 lineHeight23" placeholder="我相信榜样的力量，身先士卒影响他人一起行动。(最多100字)"  maxlength="100" (blur)="goToTop()"  (input)="onTextEnter($event, 3)"></textarea>
        <div class="submit fontSize19" (click)="onVectorSubmit(3)">
          <span>提交我的风格</span>
        </div>
      </div>
      <div id="cardBack3" class="cardBack">
        <p class="textEnterAfter1  textEnterAfter fontSize16 lineHeight23" id="textEnterAfter3"></p>
        <div class="submit2 fontSize19" (click)="onVectorClose()">
          <span>关闭</span>
        </div>
      </div>
    </div>
    <div class="card" id="card4">
      <div>
        <img class="cardFrontImage" alt="" src="{{assetsRoute}}/picture/courselearning/desert.png"  id="cardFrontImage4" />
      </div>
      <div class="fontSize18 cardText">
        太阳
      </div>
      <div class="cardFront" id="cardFront4">
        <textarea id="textEnter4" class="textEnterNormal fontSize16 lineHeight23" placeholder="我的热情就像一把火，影响的可不只是沙漠。(最多100字)"  maxlength="100" (blur)="goToTop()"  (input)="onTextEnter($event, 4)"></textarea>
        <div class="submit fontSize19" (click)="onVectorSubmit(4)">
          <span>提交我的风格</span>
        </div>
      </div>
      <div id="cardBack4" class="cardBack">
        <p class="textEnterAfter1 textEnterAfter fontSize16 lineHeight23" id="textEnterAfter4"></p>
        <div class="submit2 fontSize19" (click)="onVectorClose()">
          <span>关闭</span>
        </div>
      </div>
    </div>
    <div class="card" id="card5">
      <div>
        <img class="cardFrontImage" alt="" src="{{assetsRoute}}/picture/courselearning/zhiduoxing.png"  id="cardFrontImage5"/>
      </div>
      <div class="fontSize18 cardText">
        智多星
      </div>
      <div class="cardFront" id="cardFront5">
        <textarea id="textEnter5" class="textEnterNormal fontSize16 lineHeight23" placeholder="思如泉涌的我总能得到别人的认同。(最多100字)"  maxlength="100" (blur)="goToTop()"  (input)="onTextEnter($event, 5)"></textarea>
        <div class="submit fontSize19" (click)="onVectorSubmit(5)">
          <span>提交我的风格</span>
        </div>
      </div>
      <div id="cardBack5" class="cardBack">
        <p class="textEnterAfter1  textEnterAfter fontSize16 lineHeight23" id="textEnterAfter5"></p>
        <div class="submit2 fontSize19" (click)="onVectorClose()">
          <span>关闭</span>
        </div>
      </div>
    </div>
    <div class="card" id="card6">
      <div>
        <img class="cardFrontImage" alt="" src="{{assetsRoute}}/picture/courselearning/pine.png"  id="cardFrontImage6"/>
      </div>
      <div class="fontSize18 cardText">
        松树
      </div>
      <div class="cardFront" id="cardFront6">
        <textarea id="textEnter6" class="textEnterNormal fontSize16 lineHeight23" placeholder="咬定青山不放松，坚韧的我没有影响不了的人。(最多100字)"  maxlength="100" (blur)="goToTop()"  (input)="onTextEnter($event, 6)"></textarea>
        <div class="submit fontSize19" (click)="onVectorSubmit(6)">
          <span>提交我的风格</span>
        </div>
      </div>
      <div id="cardBack6" class="cardBack">
        <p class="textEnterAfter1 textEnterAfter fontSize16 lineHeight23" id="textEnterAfter6"></p>
        <div class="submit2 fontSize19" (click)="onVectorClose()">
          <span>关闭</span>
        </div>
      </div>
    </div>
    <div class="card" id="card7">
      <div class="cardFront" id="cardFront7">
        <span class="cardText fontSize18">以上都不是我的风格</span>
        <textarea id="textEnter7" class="textEnterNormal2 fontSize16 lineHeight23" placeholder="输入我想说的话...(最多100字)"  maxlength="100" (blur)="goToTop()"  (input)="onTextEnter($event, 7)"></textarea>
        <div class="submit fontSize19" (click)="onVectorSubmit(7)">
          <span>提交我的风格</span>
        </div>
      </div>
      <div id="cardBack7" class="cardBack">
        <h1 class="fontSize16">我的影响力风格</h1>
        <img src="{{assetsRoute}}/picture/courselearning/upperquote.png" id="upperquote">
        <img src="{{assetsRoute}}/picture/courselearning/lowerquote.png" id="lowerquote">
        <p class="textEnterAfter2 textEnterAfter fontSize16 lineHeight23" id="textEnterAfter7"></p>
        <div class="submit2 fontSize21" (click)="onVectorClose()">
          <span>关闭</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="shade"></div>
<div id="guide"  *ngIf="learningPath">
  <div id="guideImageWrap">
    <!-- 引导界面需要加入learning path来进行判断 -->
    <!-- <img src="../{{assetsRoute}}/picture/courselearning/mindy.png" alt="" class="guideImage"> -->
    <!--<img src="../{{assetsRoute}}/picture/courselearning/Rita.png" alt="" class="guideImage">-->
    <img src="{{assetsRoute}}/picture/courselearning/Mindy_new.png" alt="" class="guideImage" *ngIf="learningPath.name!='打造高效团队'&&learningPath.name!='领导力精要'&&learningPath.name!='协作'&&learningPath.name!='计划与组织'&&learningPath.name!='影响力'&&learningPath.name!='领导力启程'&&learningPath.name!='驱动变革'&&learningPath.name!='影响力专业版'">
    <img src="{{assetsRoute}}/picture/courselearning/Alex.png" alt="" class="guideImage" *ngIf="learningPath.name=='打造高效团队'||learningPath.name=='解决冲突'">
    <img src="{{assetsRoute}}/picture/courselearning/Rita.png" alt="" class="guideImage" *ngIf="learningPath.name=='领导力精要'||learningPath.name=='领导力启程'">
    <img src="{{assetsRoute}}/picture/courselearning/Mike.png" alt="" class="guideImage" *ngIf="learningPath.name=='协作'">
    <img src="{{assetsRoute}}/picture/courselearning/lilith.png" alt="" class="guideImage" *ngIf="learningPath.name=='计划与组织'">
    <img src="{{assetsRoute}}/picture/courselearning/Diana.png" alt="" class="guideImage" *ngIf="learningPath.name=='影响力'||learningPath.name=='驱动变革'||learningPath.name=='影响力专业版'">
  </div>
  <div id="guideText" class="fontSize16 lineHeight24">
     <!-- <span>你已经完成了引导</span> -->
     <p [innerHtml]="chuanjie" class="fontSize16 lineHeight21"></p>
  </div>
  <div id="guideBtn" class="fontSize18" (click)="guideAnimateOut()">
    <span *ngIf="learningPath.name=='领导力精要'||learningTour || this.learningDirect">进入课程学习</span>
    <span *ngIf="learningPath.name!='领导力精要'&&!learningTour && !this.learningDirect">进入能力诊断</span>
  </div>
</div>

<div id="shade3">
  <div id="slideTipText2" class="fontSize18">请输入我想说的话...</div>
</div>



// WEBPACK FOOTER //
// ./src/app/vector.component.html